import { render, staticRenderFns } from "./DatesDialog.vue?vue&type=template&id=0e3974e4&scoped=true&"
import script from "./DatesDialog.vue?vue&type=script&lang=js&"
export * from "./DatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3974e4",
  null
  
)

export default component.exports